module.exports = __webpack_public_path__ + "static/media/fb-container-black.3d6c6556.svg";